import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import MainLayout from '@/layouts/Main'
import AdminLayout from '@/layouts/Admin'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Index from '@/pages/Index'
import OneClick from '@/pages/oneclick/OneClick'
import OneClickReport from '@/pages/oneclick/OneClickReport'
import OneClickReportDetail from '@/pages/oneclick/OneClickReportDetail'
import Extend from '@/pages/extend/Extend'
import ExtendReport from '@/pages/extend/ExtendReport'
import Epa from '@/pages/epa/Epa'
import EpaReport from '@/pages/epa/EpaReport'
import MapPopup from '@/pages/MapPopup'
import Product from '@/pages/Product'
import DashBoard from '@/pages/solarhome/DashBoard'
import Customer from '@/pages/solarhome/Customer'
import FindMyInfo from '@/pages/FindMyInfo'
import Vpp from '@/pages/Vpp'
import Insurance from '@/pages/onm/Insurance'
import InsuranceApply from '@/pages/onm/InsuranceApply'
import Care from '@/pages/onm/care'
import Contact from '@/pages/cscenter/Contact'
import Notice from '@/pages/cscenter/Notice'
import Faq from '@/pages/cscenter/Faq'
import MyPage from '@/pages/MyPage'
import MyCoupon from '@/pages/MyCoupon'
import Pricing from '@/pages/pricing/Pricing'
import PricingResult from '@/pages/pricing/PricingResult'

// Admin Pages
import AdminDashboard from '@/pages/admin/Dashboard'
import Partner from '@/pages/admin/Partner'
import PublishCoupon from '@/pages/admin/PublishCoupon'
import UseCoupon from '@/pages/admin/UseCoupon'

Vue.use(Router)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}
    // new navigation.
    // scroll to anchor by returning the selector
    if (to.hash) {
      position.selector = to.hash
    }
    // check if any matched route config has meta that requires scrolling to top
    if (to.matched.some(m => m.meta.scrollToTop)) {
      // cords will be used if no selector is provided,
      // or if the selector didn't match any element.
      position.x = 0
      position.y = 0
    }
    // if the returned position is falsy or an empty object,
    // will retain current scroll position.
    return position
  }
}

const DefaultRouterView = { template: '<router-view/>' }

const router = new Router({
  // mode: 'history',
  base: __dirname,
  scrollBehavior,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      component: MainLayout,
      children: [
        {
          name: 'index',
          path: '',
          component: Index,
          meta: {
            title: '비즈해줌',
            scrollToTop: true,
            useFooter: true
          }
        },
        {
          name: 'login',
          path: 'login',
          component: Login,
          meta: {
            title: '로그인 | 비즈해줌',
            scrollToTop: true
          }
        },
        {
          name: 'register',
          path: 'register',
          component: Register,
          meta: {
            title: '회원가입 | 비즈해줌',
            scrollToTop: true
          }
        },
        {
          name: 'findmyinfo',
          path: 'findmyinfo',
          component: FindMyInfo,
          meta: {
            title: '계정찾기 | 비즈해줌',
            scrollToTop: true
          }
        },
        {
          path: 'oneclick',
          component: DefaultRouterView,
          children: [
            {
              name: 'oneclick',
              path: '',
              component: OneClick,
              meta: {
                title: '태양광 원클릭사업검토 ㅣ 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'oneclickNew',
              path: 'report',
              component: OneClickReport,
              meta: {
                title: '태양광 원클릭사업검토 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'oneclickNewDetail',
              path: 'reportDetail',
              component: OneClickReportDetail,
              meta: {
                title: '태양광 원클릭사업검토 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'oneclickLoad',
              path: 'report/:id(\\d+)',
              component: OneClickReport,
              meta: {
                title: '태양광 원클릭사업검토 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'oneclickLoadDetail',
              path: 'reportDetail/:id(\\d+)',
              component: OneClickReportDetail,
              meta: {
                title: '태양광 원클릭사업검토 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            }
          ]
        },
        {
          path: 'extend',
          component: DefaultRouterView,
          children: [
            {
              name: 'extend',
              path: '',
              component: Extend,
              meta: {
                title: '태양광 프리미엄보고서 ㅣ 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'extendNew',
              path: 'report',
              component: ExtendReport,
              meta: {
                title: '태양광 프리미엄보고서 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'extendLoad',
              path: 'report/:id(\\d+)',
              component: ExtendReport,
              meta: {
                title: '태양광 프리미엄보고서 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            }
          ]
        },
        {
          path: 'electric-power-analysis',
          component: DefaultRouterView,
          children: [
            {
              name: 'epa',
              path: '',
              component: Epa,
              meta: {
                title: '',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'epaNew',
              path: 'report',
              component: EpaReport,
              meta: {
                title: '',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            },
            {
              name: 'epaLoad',
              path: 'report/:id(\\d+)',
              component: EpaReport,
              meta: {
                title: '',
                scrollToTop: true,
                parentCode: 'REVIEW'
              }
            }
          ]
        },
        {
          name: 'solarhome',
          path: 'solarhome',
          component: DefaultRouterView,
          redirect: { name: 'dashboard' },
          children: [
            {
              path: 'dashboard',
              name: 'dashboard',
              component: DashBoard,
              meta: {
                title: '태양광 대여사업 대시보드 | 비즈해줌',
                scrollToTop: true,
                parentCode: 'RENTAL'
              }
            },
            {
              path: 'customer',
              name: 'customer',
              component: Customer,
              meta: {
                title: '태양광 대여사업 고객관리 | 비즈해줌',
                scrollToTop: true,
                parentCode: 'RENTAL'
              }
            }
          ]
        },
        {
          name: 'product',
          path: 'product',
          component: Product,
          meta: {
            title: '태양광 패널 인버터 구매 ㅣ 비즈해줌',
            scrollToTop: true,
            useFooter: true,
            parentCode: 'BUY'
          }
        },
        {
          name: 'vpp',
          path: 'vpp',
          component: Vpp,
          meta: {
            title: '전력중개사업 ㅣ 비즈해줌',
            scrollToTop: true,
            useFooter: true,
            parentCode: 'ONM'
          }
        },
        {
          path: 'insurance',
          component: DefaultRouterView,
          children: [
            {
              name: 'insurance',
              path: '',
              component: Insurance,
              meta: {
                title: '태양광 보험대행 ㅣ 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'ONM'
              }
            },
            {
              name: 'insuranceApply',
              path: 'apply',
              component: InsuranceApply,
              meta: {
                title: '태양광 보험대행 ㅣ 비즈해줌',
                scrollToTop: true,
                parentCode: 'ONM'
              }
            }
          ]
        },
        {
          name: 'care',
          path: 'care',
          component: Care,
          meta: {
            title: '태양광 유지관리 비즈케어 ㅣ 비즈해줌',
            scrollToTop: true,
            useFooter: true,
            parentCode: 'ONM'
          }
        },
        {
          name: 'cscenter',
          path: 'cscenter',
          redirect: { name: 'contact' },
          component: DefaultRouterView,
          children: [
            {
              name: 'contact',
              path: 'contact',
              component: Contact,
              meta: {
                title: '제휴문의 ㅣ 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'CSCENTER'
              }
            },
            {
              name: 'notice',
              path: 'notice',
              component: Notice,
              meta: {
                title: '공지사항 ㅣ 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'CSCENTER'
              }
            },
            {
              name: 'faq',
              path: 'faq',
              component: Faq,
              meta: {
                title: '자주묻는질문 | 비즈해줌',
                scrollToTop: true,
                useFooter: true,
                parentCode: 'CSCENTER'
              }
            }
          ]
        },
        {
          path: 'pricing',
          component: DefaultRouterView,
          children: [
            {
              name: 'pricing',
              path: '',
              component: Pricing,
              meta: {
                title: '이용권 | 비즈해줌',
                scrollToTop: true,
                useFooter: true
              }
            },
            {
              name: 'pricingResult',
              path: 'result',
              component: PricingResult,
              meta: {
                title: '이용권 | 비즈해줌',
                scrollToTop: true,
                useFooter: true
              }
            }
          ]
        },
        {
          name: 'mypage',
          path: 'mypage',
          component: MyPage,
          meta: {
            title: '마이페이지 | 비즈해줌',
            scrollToTop: true,
            useFooter: true
          }
        },
        {
          name: 'mycoupon',
          path: 'coupon',
          component: MyCoupon,
          meta: {
            title: '이용권관리 | 비즈해줌',
            scrollToTop: true,
            useFooter: true
          }
        }
      ]
    },
    {
      path: '/map',
      name: 'map',
      component: MapPopup,
      meta: {
        title: '지도정보 | 비즈해줌',
        scrollToTop: true
      }
    },
    {
      name: 'admin',
      path: '/admin',
      component: AdminLayout,
      redirect: { name: 'adminDashboard' },
      children: [
        {
          name: 'adminDashboard',
          path: 'dashboard',
          component: AdminDashboard,
          meta: {
            title: '대시보드 | 비즈해줌 관리자',
            scrollToTop: true,
            parentCode: 'DASHBOARDADMIN'
          }
        },
        {
          name: 'partner',
          path: 'partner',
          component: Partner,
          meta: {
            title: '회원사목록 | 비즈해줌 관리자',
            scrollToTop: true,
            parentCode: 'PARTNERADMIN'
          }
        },
        {
          name: 'publishCoupon',
          path: 'coupon/publish',
          component: PublishCoupon,
          meta: {
            title: '이용권 쿠폰 관리 | 비즈해줌 관리자',
            scrollToTop: true,
            parentCode: 'COUPONADMIN'
          }
        },
        {
          name: 'useCoupon',
          path: 'coupon/use',
          component: UseCoupon,
          meta: {
            title: '이용권 쿠폰 관리 | 비즈해줌 관리자',
            scrollToTop: true,
            parentCode: 'COUPONADMIN'
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // 각 페이지별 title 설정
  const title = to.meta.title
  document.title = typeof title !== 'undefined' ? title : '비즈해줌'

  // 인증이 필요하고 로그인 한 경우를 확인하기
  // 그렇지 않은 경우에는 로그인 페이지로 Redirect 하기
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.user.isLogin) {
      next({
        path: '/login',
        query: {next: to.fullPath}
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js